// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__36LUG","signatureBlock":"Footer_signatureBlock__LjjEi","signature":"Footer_signature__1jXs0"};